module.exports = __webpack_public_path__ + "img/icon_notice_color.0f4795be.svg";